import { render, staticRenderFns } from "./PopupDanger.vue?vue&type=template&id=4b38f563"
import script from "./PopupDanger.vue?vue&type=script&lang=js"
export * from "./PopupDanger.vue?vue&type=script&lang=js"
import style0 from "./PopupDanger.vue?vue&type=style&index=0&id=4b38f563&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports